import { render } from "./TestItem.html?vue&type=template&id=b5409098&scoped=true&ts=true"
import script from "./TestItem.ts?vue&type=script&lang=ts"
export * from "./TestItem.ts?vue&type=script&lang=ts"

import "./TestItem.css?vue&type=style&index=0&id=b5409098&scoped=true&lang=css"

import exportComponent from "/home/dev/deployment/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5409098"]])

export default __exports__